import { FormOptionsModel } from "../data-model/formOptions";

/**
 * Returns the option rows stored on a form_options document.
 *
 * @param options - Documents loaded into the formOptions Redux slice.
 * @param id - form_options document id to read.
 * @return The matching document's option rows, or an empty list.
 */
export const getAllRelevantOptions = (
  options: FormOptionsModel[],
  id: string,
) => {
  const requiredOption = options.find((option) => option.id === id);
  if (!requiredOption) {
    return [];
  }
  return requiredOption.data;
};
